const mergedEn = require('../../packages/i11n/src/locale/merged.en.json')
const mergedEs = require('../../packages/i11n/src/locale/merged.es.json')

const nextI18NextConfig = {
  i18n: {
    defaultLocale: 'es',
    localeDetection: false,
    locales: ['es', 'en'],
  },
  defaultNS: 'common',
  ns: ['common'],
  fallbackLng: 'es',
  localePath: null,
  resources: {
    en: {
      common: mergedEn,
    },
    es: {
      common: mergedEs,
    },
  },
  serializeConfig: false,
}

module.exports = nextI18NextConfig
